import { genNameInitials } from "@/utils/name";

import type { AppUser, Person } from "../types";

/**
 * APIから取得したデータからPersonオブジェクトを生成するアダプター関数
 *
 * @param worker, person APIから取得したデータ、など
 * @returns Personオブジェクト、またはundefined
 */
export const createPersonObject = <
  T extends { id: string; name: string; email?: string; avatarUrl?: string },
>(
  worker: T | undefined,
): Person | undefined => {
  if (!worker) {
    return undefined;
  }

  return {
    id: worker.id,
    name: worker.name,
    email: worker.email ?? "",
    avatarUrl: worker.avatarUrl ?? "",
    nameInitials: genNameInitials(worker.name),
  };
};

/**
 * APIから取得したデータからAppUserオブジェクトを生成するアダプター関数
 *
 * @param user APIから取得したデータのuserオブジェクト
 * @returns AppUserオブジェクト、またはundefined
 */
export const createUserObject = <
  T extends {
    id: string;
    name?: string;
    displayName?: string;
    email?: string;
    avatarUrl?: string;
  },
>(
  user: T | undefined,
): AppUser | undefined => {
  if (!user) {
    return undefined;
  }

  return {
    id: user.id,
    name: user.name,
    displayName: user.displayName,
    email: user.email,
    nameInitials: user.name ? genNameInitials(user.name) : "",
    avatarUrl: user.avatarUrl,
  };
};
